import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPypyComponent } from './simple-icons-pypy.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPypyComponent ],
    exports:      [ SimpleIconsPypyComponent ],
    bootstrap:    []
})
export class SimpleIconsPypyModule {}
